import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _omit from "lodash/omit";
import _pick from "lodash/pick";
import _isUndefined from "lodash/isUndefined";
import _isNull from "lodash/isNull";
import _pickBy from "lodash/pickBy";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import TypeImpl from './TypeImpl';
import TypographyContext, { TypographyContextProvider } from './TypographyContext';
// These are the values we need to supply to child components via TypographyContext
// Should be kept in sync with the `TypeVisualProps` type definition in `TypeImpl.ts `
var VISUAL_PROPS = ['bold', 'chronicle', 'color', 'error', 'gotham', 'inline', 'italic', 'light', 'size', 'uppercase'];
var Type = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      component = _ref.component,
      otherProps = _objectWithoutProperties(_ref, ["children", "component"]);

  var typographyContext = useContext(TypographyContext); // ensure that component props are not null so defaults spread evenly

  var props = _pickBy(otherProps, function (val) {
    return !_isNull(val);
  }); // supply any undefined or null visual props from TypographyContext
  // gotham and chronicle are mutually exclusive. Values in props must override values in context.
  // Without unsetting the other font type, a nested <Type/> will receive both props, which
  // is undefined behavior and has the effect of rendering chronicle. This also must be done in TypographyContext
  // See https://github.com/NerdWallet/structured-content/pull/298


  var propsFromContext = _pickBy(typographyContext, function (val, key) {
    if (key === 'gotham' && val && props.chronicle) return false;
    if (key === 'chronicle' && val && props.gotham) return false;
    return _isUndefined(props[key]);
  });

  var passedPropsMergedWithPropsFromContext = _objectSpread(_objectSpread(_objectSpread({}, propsFromContext), props), {}, {
    component: component
  });

  return /*#__PURE__*/React.createElement(TypographyContextProvider // provide all needed props as context for child <Type /> nodes
  , _extends({}, _pick(props, VISUAL_PROPS), {
    // nested type is always `inline`
    inline: true
  }), /*#__PURE__*/React.createElement(TypeImpl, _extends({}, passedPropsMergedWithPropsFromContext, {
    ref: ref
  }), children));
});
Type.displayName = 'Type';
Type.propTypes = _omit(TypeImpl.propTypes, 'inline');
export default Type;
export { TypographyContext, TypographyContextProvider };